import { render, staticRenderFns } from "./GFZ.vue?vue&type=template&id=6c028834&scoped=true"
import script from "./GFZ.vue?vue&type=script&lang=js"
export * from "./GFZ.vue?vue&type=script&lang=js"
import style0 from "./GFZ.vue?vue&type=style&index=0&id=6c028834&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c028834",
  null
  
)

export default component.exports